import { LockOpenedIcon } from '@carboncopyco/icons';
import type { ConfirmAlertProps } from '@carboncopyco/ui';
import { ConfirmAlert, TextBase, notify } from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';

export interface RuleUnlockAlertProps
  extends Pick<ConfirmAlertProps, 'onClose'> {
  open: ConfirmAlertProps['show'];
  onConfirm: () => Promise<unknown>;
  onErrorMessage?: string;
}

export const RuleUnlockAlert = ({
  open,
  onClose,
  onConfirm,
  onErrorMessage = 'Failed to unlock rule',
}: RuleUnlockAlertProps) => {
  const [unlocking, setUnlocking] = useBoolean();

  const onUnlock = async () => {
    setUnlocking.setTrue();
    try {
      await onConfirm?.();
    } catch (_e) {
      notify.error(onErrorMessage);
    }
    setUnlocking.setFalse();
  };

  return (
    <ConfirmAlert
      show={open}
      title="Unlock this rule?"
      danger
      yesLabel="Unlock"
      yesIcon={<LockOpenedIcon />}
      onConfirm={onUnlock}
      onClose={onClose}
      disabled={unlocking}
    >
      <div className="flex flex-col gap-2.5 pr-12 w-ds-normal-modal">
        <TextBase
          label="This rule has been locked for editing. are you sure you
want lo unlock it?"
        />
      </div>
    </ConfirmAlert>
  );
};
